module.exports = __webpack_public_path__ + "img/projects.5b1859cc.svg";